import * as apiPostSearch from 'apiAuto/backend/paths/PostAccessorySearchV1';
import { Characteristic } from 'enums/characteristic';
import * as Accessory from 'types/Accessory/Search/Accessory';

export type Type = Accessory.Type[];

export function create(): Type {
	return [];
}

export function mapFromApi(obj: apiPostSearch.ResponseData): Type {
	return obj.data.map((x) => ({
		...x,
		categories: x.categories.map((y) => ({
			description: y.name,
			id: y.id,
		})),
		characteristic: x.characteristic as Characteristic,
		tags: x.tags,
	}));
}
